var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"laboratory_editor"},[_c('Editor',{staticClass:"ql-editor",attrs:{"api-key":"l7sh2dxxrs3sxl7jtclbldfqtbtl3lm393r8ohnocscg0l0s","init":_vm.editorInit},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }